import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useBranch } from '@/features/branch/branch-context';
import { api, type PageMeta } from '@/lib/api';
import type { DeletedAppAccount, DeletedAppAccountsQuery } from './types';

function useBranchKey() {
  const { selected, canSelectAll } = useBranch();
  return selected?.id ?? (canSelectAll ? 'all' : 'none');
}

/**
 * GET /app-accounts/deleted (patients:read): app accounts patients deleted,
 * newest first, with the clinic records they held at the branch (or, with
 * "All", every branch of the role).
 */
export function useDeletedAppAccounts(query: DeletedAppAccountsQuery) {
  const branch = useBranchKey();
  return useQuery({
    queryKey: ['deleted-app-accounts', branch, query],
    queryFn: ({ signal }) =>
      api.get<DeletedAppAccount[], PageMeta>('/app-accounts/deleted', {
        signal,
        query: { ...query },
      }),
    enabled: branch !== 'none',
    placeholderData: keepPreviousData,
  });
}
